import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import APIDocumentationPage from "@/pages/admin/APIDocumentationPage";

export const Route = createFileRoute("/_admin/admin/api-docs")({
  head: () => pageHead("Admin · Api Docs", "AKIVA admin · api docs portal.", "/admin/api-docs", true),
  component: APIDocumentationPage,
});
